import ViewBase from "../view-base.view";
import PhotoListItemView from "./photo-list-item.view";
import PhotoDetailsView from "./photo-details.view";
import GscmDivisionTreeCheckboxComponent from "../../components/gscm-division/gscm-division-tree-checkbox.component";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import MultiSelectComponent from "../../components/multi-select/multi-select.component";
import paginationComponent from "../../components/pagination/pagination.component";
import SelectSiteComponent from "../../components/site/select-site.component";
import SelectUserComponent from "../../components/user/select-user.component";
import LocationTreeCheckboxComponent from "../../components/location/location-tree-checkbox.component";
import languageModel from "../../models/language.model";
import photoModel from "../../models/photo/photo.model";
import codeMasterModel from "../../models/common/code-master.model";
import { codeMasterType } from "../../config/constants";
import { formats as FORMATS } from "../../config/constants";
import moment from "moment";

export default function PhotoListView() {
  ViewBase.call(this);

  let selectedPhotoItem;
  let isShowingPhotoDetailsPage = false;
  let isDownloadingExcel = false;
  let isDownloadingPpt = false;
  let photoList = [];
  let pictureTypeList = [];
  let selectedPictureTypeList = [];
  let selectedGscmDivisionCodeList = [];
  let selectedLocationCodeList = [];
  let selectedSiteList = [];
  let selectedPromoterList = [];
  let userRoleList = [];
  let selectedUserRoles = [];
  let checkedAll = false;

  let sortOptions = [
    { code: 0, get name() { return languageModel.getText("LT00000132", "Date") + ': ' + languageModel.getText("LT00000558", "Latest first") }, sortBy: 'surveyDate', order: 'DESC' },
    { code: 1, get name() { return languageModel.getText("LT00000132", "Date") + ': ' + languageModel.getText("LT00000559", "Oldest first") }, sortBy: 'surveyDate', order: 'ASC' },
    { code: 2, get name() { return languageModel.getText("LT00000012", "Description") + ': A - Z' }, sortBy: 'description', order: 'ASC' },
    { code: 3, get name() { return languageModel.getText("LT00000012", "Description") + ': Z - A' }, sortBy: 'description', order: 'DESC' },
    { code: 4, get name() { return languageModel.getText("LT00000556", "Picture Type") + ': A - Z' }, sortBy: 'pictureType', order: 'ASC' },
    { code: 5, get name() { return languageModel.getText("LT00000556", "Picture Type") + ': Z - A' }, sortBy: 'pictureType', order: 'DESC' },
    { code: 6, get name() { return languageModel.getText("LT00000557", "Location") + ': A - Z' }, sortBy: 'location', order: 'ASC' },
    { code: 7, get name() { return languageModel.getText("LT00000557", "Location") + ': Z - A' }, sortBy: 'location', order: 'DESC' },
    { code: 8, get name() { return languageModel.getText("LT00000071", "Site") + ': A - Z' }, sortBy: 'siteName', order: 'ASC' },
    { code: 9, get name() { return languageModel.getText("LT00000071", "Site") + ': Z - A' }, sortBy: 'siteName', order: 'DESC' },
  ];

  let selectedSortOption = sortOptions[0];
  let selectedSortIndex = 0;

  let filterParams = {
    fromDate: moment().add(-1, 'M').format(FORMATS.apiDateFormat),
    toDate: moment().format(FORMATS.apiDateFormat),
    location: '',
    product: '',
    pictureType: '',
    siteId: '',
    promoterId: '',
    description: '',
    sortBy: selectedSortOption.sortBy,
    orderBy: selectedSortOption.order,
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0,
    userRoles: '',
    selectedPhotoIds: []
  }

  let lastSearchedFilterParams = {};
  Object.assign(lastSearchedFilterParams, filterParams);

  let showDetailsPage = (photoObj) => {
    selectedPhotoItem = photoObj;
    isShowingPhotoDetailsPage = true;
  };

  let hideDetailsPage = () => {
    isShowingPhotoDetailsPage = false;
    selectedPhotoItem = undefined;
  }

  let checkSelectedAll = () => {
    // If any are not checked, checkedAll = false
    checkedAll = !photoList.some(x => !x.checked);
  }

  let _checkedAll = (e) => {
    checkedAll = e.target.checked;
    photoList.forEach(x => { x.checked = e.target.checked; })
  }

  let getPhotoList = () => {
    this.showLoading();
    checkedAll = false;
    photoList = [];
    photoModel.getPhotoList(filterParams)
      .then((result) => {
        lastSearchedFilterParams = {};
        Object.assign(lastSearchedFilterParams, filterParams);

        filterParams.pageIndex = result.pageIndex;
        filterParams.pageSize = result.pageSize;
        filterParams.totalCount = result.total;
        result.data.forEach((element, index) => {
          element["rowId"] = index;
          element["checked"] = checkedAll;
          photoList.push(element);
        });
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      })
  };

  let searchPhotos = () => {
    filterParams.pageIndex = 1; // Always go back to page 1 
    getPhotoList();
  }

  let clearFilters = () => {
    filterParams = {
      fromDate: moment().add(-1, 'M').format(FORMATS.apiDateFormat),
      toDate: moment().format(FORMATS.apiDateFormat),
      location: '',
      product: '',
      pictureType: '',
      siteId: '',
      promoterId: '',
      description: '',
      userRoles: '',
      sortBy: selectedSortOption.sortBy,
      orderBy: selectedSortOption.order,
      pageIndex: 1,
      selectedPhotoIds: []
    }

    // Clear selections
    selectedGscmDivisionCodeList = [];
    selectedPictureTypeList = [];
    selectedLocationCodeList = [];
    selectedSiteList = [];
    selectedPromoterList = [];
    selectedUserRoles = [];

    // Reload data
    getPhotoList();
  }

  let _downloadExcel = (e) => {
    e.preventDefault();
    if (isDownloadingExcel) {
      return false;
    }
    lastSearchedFilterParams.selectedPhotoIds = selectedPhotoIds();
    isDownloadingExcel = true;
    photoModel.exportPhotoListToExcel(lastSearchedFilterParams)
      .then(() => { })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        isDownloadingExcel = false;
      });

    return false;
  }

  let _downloadPPT = (e) => {
    e.preventDefault();
    if (isDownloadingPpt) {
      return false;
    }
    lastSearchedFilterParams.selectedPhotoIds = selectedPhotoIds();
    isDownloadingPpt = true;
    photoModel.exportPhotoListToPptx(lastSearchedFilterParams)
      .then(() => { })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        isDownloadingPpt = false;
      });

    return false;
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    filterParams.pageIndex = pageIndex;
    filterParams.pageSize = pageSize;
    getPhotoList();
  }

  let onPageChanged = (pageIndex) => {
    filterParams.pageIndex = pageIndex;
    getPhotoList();
  }

  let updateFilter = (e) => {
    let prop = e.currentTarget.id;
    let value = e.currentTarget.value;
    if (prop && prop.length > 0) {
      filterParams[prop] = value
    }
  }

  let sortList = () => {
    filterParams.sortBy = selectedSortOption.sortBy
    filterParams.orderBy = selectedSortOption.order;
    filterParams.pageIndex = 1; // Go back to page 1
    getPhotoList();
  }

  let getPictureTypeList = () => {
    pictureTypeList = [];
    photoModel.getPictureTypeList()
      .then((result) => {
        pictureTypeList = result;
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  let getUserRoleList = () => {
    userRoleList = [];
    codeMasterModel.getByCategory(
      (result) => {
        userRoleList = result;
      },
      (error) => {
        this.handleError(error);
      },
      { category: codeMasterType.userRole } // UserRole
    );
  }
  let selectedPhotoIds = () => {
    return photoList.filter(x => x.checked).map(u => u.photoIdString);
  }
  return {
    oninit: () => {
      getPhotoList();
      getPictureTypeList();
      getUserRoleList();
    },
    view: () => {
      return [
        m('.row',
          m('.col-12',
            !isShowingPhotoDetailsPage
              ? [ // Show Search / Listing page
                // Search section
                m('.d-flex.flex-column.align-items-end.gap-2.mb-4',
                  m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
                    m('i.bi.bi-filter'),
                    this.getText("LT00000232", "Filter"),
                  ),
                  m('#search-section.collapse.w-100.show',
                    m('.card',
                      m('.card-body',
                        m('.row.g-4.align-items-end',
                          m('.col-xl-3.col-lg-4.col-sm-6',
                            m('label.form-label', this.getText("LT00000070", "Date Range")),
                            m(DatePickerComponent, {
                              class: 'form-control',
                              isRange: true,
                              grid: 1,
                              calendars: 1,
                              dateStart: moment(filterParams.fromDate).format(FORMATS.dateFormat), // default date range
                              dateEnd: moment(filterParams.toDate).format(FORMATS.dateFormat), // default date range
                              readonly: true,
                              onselect: (e) => {
                                filterParams.fromDate = moment(e.detail.start).format(FORMATS.apiDateFormat);
                                filterParams.toDate = moment(e.detail.end).format(FORMATS.apiDateFormat);
                              }
                            })
                          ),
                          m('.col-xl-3.col-lg-4.col-sm-6',
                            m('label.form-label', this.getText("LT00000556", "Picture Type")),
                            m(MultiSelectComponent, {
                              items: pictureTypeList,
                              selectedItems: selectedPictureTypeList,
                              onSelect: (s) => {
                                selectedPictureTypeList = s;
                                filterParams.pictureType = s.map(x => x.code).join('^');
                              }
                            }),
                          ),
                          m('.col-xl-3.col-lg-4.col-sm-6',
                            m('label.form-label', this.getText("LT00000579", "Product")),
                            m(GscmDivisionTreeCheckboxComponent, {
                              selectedCodes: selectedGscmDivisionCodeList,
                              isLevel1Expanded: true,
                              onChange: (selectedParents, selectedChildren) => {
                                selectedGscmDivisionCodeList = selectedParents;
                                filterParams.product = selectedParents.join('^');
                              }
                            })
                          ),
                          m('.col-xl-3.col-lg-4.col-sm-6',
                            m('label.form-label[for=description]', this.getText("LT00000012", "Description")),
                            m('input.form-control[id=description]', { onchange: updateFilter, value: filterParams.description })
                          ),
                          m('.col-xl-3.col-lg-4.col-sm-6',
                            m('label.form-label[for=location]', this.getText("LT00000557", "Location")),
                            m(LocationTreeCheckboxComponent, {
                              selectedCodes: selectedLocationCodeList,
                              isLevel1Expanded: true,
                              onChange: (selectedParents, selectedChildren) => {
                                selectedLocationCodeList = selectedParents;
                                filterParams.location = selectedParents.join('^');
                              }
                            })
                          ),
                          m('.col-xl-3.col-lg-4.col-sm-6',
                            m('label.form-label', this.getText("LT00000071", "Site")),
                            m(SelectSiteComponent, {
                              selectedItemList: selectedSiteList,
                              onChange: (s) => {
                                selectedSiteList = s;
                                filterParams.siteId = s.map(x => x.code).join('^');
                              }
                            }),
                          ),
                          m('.col-xl-3.col-lg-4.col-sm-6',
                            m('label.form-label', this.getText("LT00000561", "Promoter")),
                            m(SelectUserComponent, {
                              default: {
                                userStatusCode: '0001'
                              },
                              hideMyTeam: true,
                              onSelect: (u) => {
                                selectedPromoterList = u;
                                filterParams.promoterId = selectedPromoterList.map(u => u.userID).join('^');
                              },
                              selectedUserList: selectedPromoterList,
                            }),
                          ),
                          m('.col-xl-3.col-lg-4.col-sm-6',
                            m('label.form-label', this.getText("LT00000060", "User Role")),
                            m(MultiSelectComponent, {
                              items: userRoleList,
                              selectedItems: selectedUserRoles,
                              onSelect: (s) => {
                                selectedUserRoles = s;
                                filterParams.userRoles = s.map(x => x.code).join('^');
                              }
                            }),
                          ),
                          // Search & clear buttons
                          m('.col-12.d-flex.justify-content-end.gap-2',
                            m('button.btn.btn-primary', {
                              onclick: searchPhotos
                            }, this.getText("LT00000001", "Search")),
                            m('button.btn.btn-white', {
                              onclick: clearFilters
                            }, this.getText("LT00000031", "Clear")),
                          ),
                        ),
                      )
                    ),
                  ),
                ),
                m('.d-flex.justify-content-end.align-items-end.gap-3.mb-2',
                  m('.flex-shrink-0.d-flex.align-items-center', { style: 'padding-left: 12px;' },
                    m('.form-check',
                      m('input.form-check-input#select-all-survey[type=checkbox]', {
                        checked: checkedAll,
                        onchange: (e) => { _checkedAll(e) },
                        disabled: photoList.length == 0
                      }),
                      m('label.form-check-label[for=select-all-survey]', this.getText("LT00000077", "Select all"))
                    ),
                  ),
                  m('.surveytype-legend.flex-grow-1.d-flex.flex-wrap.align-items-center.gap-3.ps-md-4.ps-lg-5.mb-1'),
                  m('div',
                    m(SingleSelectComponent, {
                      allowEmpty: false,
                      selectedItem: selectedSortOption,
                      items: sortOptions,
                      filterable: false,
                      onSelect: e => {
                        selectedSortIndex = sortOptions.findIndex(s => s.code === e.code);
                        selectedSortOption = sortOptions[selectedSortIndex];
                        sortList();
                      }
                    })
                  ),
                  m('.input-group.w-auto',
                    m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                      {
                        disabled: (photoList && photoList.length > 0 && !photoList.some(x => x.checked)),
                      },
                      (isDownloadingExcel || isDownloadingPpt)
                        ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
                        : m('i.bi.bi-file-earmark-arrow-down-fill'),
                      this.getText("LT00000492", "Download")
                    ),
                    m('ul.dropdown-menu',
                      m('li',
                        m('a.dropdown-item[href="javascript:void(0);"]', {
                          class: isDownloadingExcel ? 'disabled' : '',
                          onclick: _downloadExcel
                        },
                          isDownloadingExcel &&
                          m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                          this.getText("LT00000493", "Excel")
                        )
                      ),
                      m('li',
                        m('a.dropdown-item[href="javascript:void(0);"]', {
                          class: isDownloadingPpt ? 'disabled' : '',
                          onclick: _downloadPPT
                        },
                          isDownloadingPpt &&
                          m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                          this.getText("LT00000494", "PPT")
                        )
                      ),
                    ),
                  ),
                ),
                // Photo List
                m('.d-flex.flex-column.gap-2',
                  photoList && photoList.length > 0 ?
                    photoList.map((photoDetails) => [
                      m(PhotoListItemView, {
                        data: photoDetails,
                        onClick: showDetailsPage,
                        checkedAll: checkedAll,
                        checkedChanged: checkSelectedAll
                      })
                    ]) : m('.text-center.my-5', this.getText("EM00000141", "No records found."))
                ),
                // Pagination component
                photoList && photoList.length > 0 && m(".mt-3",
                  m(paginationComponent, {
                    currentPage: filterParams.pageIndex,
                    pageSize: filterParams.pageSize,
                    totalItems: filterParams.totalCount,
                    onPageChanged: onPageChanged,
                    onPageSizeChanged: onPageSizeChanged
                  })
                )
              ]
              : [ // Show Details page
                m(PhotoDetailsView, {
                  data: selectedPhotoItem,
                  close: hideDetailsPage
                })
              ]
          ),
        ),
        this.getBaseViews()
      ]
    }
  }
}
